import React from 'react';
import { Icon } from './Icon.js';
export const IconScribble = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 13C7 5.99999 20 -1.80001 14 6.99999C6.5 18 5 22 16 13.5C27 5 10.5 22 20.5 19", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconScribble.js.map